import * as React from 'react';

import {applyFilterSubmission, getFilterableFields, serializeFieldNames} from 'nutshell-core';

import {convertToObj} from 'nutshell-core/filter';
import type {FilterObject, FormattedValue, EntityListType} from 'nutshell-core/types';

import {FilterDrawer} from '../../entity-list/filters/filter-drawer';
import type {ReportURLParams} from '../../reports/report-types';

type Props = {
    fieldFilterFunction: (fieldName: string) => boolean;
    // Represents the active filters that have not been filtered out by the fieldFilterFunction.
    // They are visible in the sense that these are the filters displayed in the filter drawer.
    visibleActiveFilters: FilterObject[];
    activeFilters: FilterObject[];
    entityType: EntityListType;
    facets?: FormattedValue[];
    urlParams: ReportURLParams<'contacts'>;
    onParamChange: (...args: any) => any;
    isOpen: boolean;
    schema: any;
    shownColumns: string[];
    handleScrollToColumn: (arg1: boolean) => void;
};

export class EmailMarketingFilterDrawer extends React.PureComponent<Props> {
    render() {
        return (
            <FilterDrawer
                hasTopBorder={true}
                activeFilters={this.props.visibleActiveFilters}
                entityType={this.props.entityType}
                isOpen={this.props.isOpen}
                // @ts-expect-error
                fields={this.getFields()}
                facets={this.props.facets}
                onSubmitFilter={this.handleFilterSubmit}
                onRemoveFilter={this.handleFilterRemove}
                shownColumns={this.props.shownColumns}
                updateShownColumns={(fields, isAddingColumn) => {
                    this.props.handleScrollToColumn(isAddingColumn);
                    this.props.onParamChange(
                        {list: {fields: {[this.props.entityType]: serializeFieldNames(fields)}}},
                        true
                    );
                }}
            />
        );
    }

    getFields = () => {
        return getFilterableFields(this.props.schema, this.props.fieldFilterFunction);
    };

    /**
     * Takes a filterObj and either updates the existing version of that
     * filter or tacks it on as a new filter to our filters state.
     * @param  {object} filterObj  Filter object to update/apply
     * @return {void}
     */
    handleFilterSubmit = (filterObj: FilterObject) => {
        const listParams = this.props.urlParams.list;
        // eslint-disable-next-line @typescript-eslint/no-unused-expressions
        listParams ? (listParams.page = '1') : undefined;

        const newFilters = applyFilterSubmission(this.props.activeFilters, filterObj);

        this.props.onParamChange({filter: convertToObj(newFilters)}, false);
    };

    /**
     * Takes a filterKey (read: `owner`, `confidence`) and removes that
     * filter from the current set of filters.
     *
     * @param  {string} filterKey name of filter to remove
     * @return {void}
     */
    handleFilterRemove = (filterKey: string) => {
        const newFilters = this.props.activeFilters.filter(
            (filterObj) => !Object.prototype.hasOwnProperty.call(filterObj, filterKey)
        );
        this.props.onParamChange({filter: convertToObj(newFilters)}, false);
    };
}
